import { useMemo } from "react";

import classNames from "classnames";
import { twMerge } from "tailwind-merge";

import { faTools } from "@fortawesome/free-solid-svg-icons/faTools";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import ToolSnippet from "components/ToolSnippet";
import useAuthentication from "hooks/useAuthentication";
import { tools as allTools } from "consts/tools";

import styles from "./style.module.scss";

type ToolsPageAllProps = {
  type:
    | "explore"
    | "markets"
    | "event-driven"
    | "screeners"
    | "insight-providers"
    | "channel-partner"
    | "charting";
};

const ToolsPageAll = ({ type = "markets" }: ToolsPageAllProps) => {
  const { account: loggedInAccount } = useAuthentication();

  const tools = useMemo(
    () =>
      allTools
        .filter((t) => {
          return t.type === type;
        })
        .map((t) => {
          if (
            t.needPremiumAccess &&
            !loggedInAccount?.interfaceSetting?.[`${t?.interfaceSettingKey}`]
          ) {
            return {
              ...t,
              link: t.deniedLink,
            };
          }
          return t;
        }),
    [loggedInAccount, type]
  );

  if (tools.length < 1) {
    return (
      <div className={twMerge(styles.container, "mt-0 md:mt-[-20px]")}>
        <div className="flex flex-col w-full h-[500px] items-center justify-center">
          <FontAwesomeIcon
            icon={faTools}
            className="text-[92px] text-inactive-gray"
          />
          <h1 className="text-xl mt-[20px] text-shady-gray">
            No Tools Available
          </h1>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={twMerge(styles.container, "mt-0 md:mt-[-20px]")}>
        <div
          className={classNames(
            styles.filter,
            "flex flex-wrap gap-[30px] my-0 md:my-[20px]",
            "pt-0 md:pt-[15px] md:px-[5px]",
            "mb-[8px] md:mt-0 md:mb-0"
          )}
        >
          {tools.map((t) => {
            return <ToolSnippet tool={t} key={t.id} />;
          })}
        </div>
      </div>
    </>
  );
};

export default ToolsPageAll;
